// extracted by mini-css-extract-plugin
export var form = "change-password-module--form--WoknZ";
export var input = "change-password-module--input--NX2nz";
export var loginButton = "change-password-module--loginButton--PtVH1";